import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { FeatureContext } from '../../context api/Features/FeatureContext'

import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success, getNewToken } from '../../shared/constants'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'

export const useRazorPay = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [customer, setCustomer] = useState(false)
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [cancelToken, setCancelToken] = useState()
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [paginate, setPaginate] = useState({})

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  //CUSTOMER
 
  const purchaseSubscription = async (props, response)=>{
    await axios.post(API.PURCHASE_SUBSCRIPTION, {
        purchaseId: props.purchaseId ,
        subscriptionId: props.subscriptionId,
        validityPeriod: props.validityPeriod,
        razorpayPaymentId: response?.razorpay_payment_id,
        razorpayOrderId: response?.razorpay_order_id,
        razorpaySignature: response?.razorpay_signature,
        trial: false,
    }, 
    header)
    .then(order=>{
        toastMessage("Subscription purchased successfully", 'success')
        props.callBck && props.callBck()
        window.location.reload()
        console.log(order)
    }).catch(err=>{
        alert("something went wrong in creating order");
    });
  }

  const trySubscription = async (props, reload = true, redirect = "")=>{
    // alert("trial")
    await axios.post(API.PURCHASE_SUBSCRIPTION, {
        subscriptionId: props.subscriptionId,
        validityPeriod: props.validityPeriod,
        amount: props.amount,
        trial: true,
        companyAdminId: props.companyAdminId,
        offlinePayment: props.offlinePayment, //
        offlinePaymentRefNumber: props.offlinePaymentRefNumber,
        fromAdmin: props.fromAdmin
    }, 
    header)
    .then(order=>{
        toastMessage("Subscription Trial added successfully", 'success')
        if(redirect!== ""){
          history.push(ROUTES[redirect]);
        }
        reload && window.location.reload()
        console.log(order)
    }).catch(err=>{
        alert("something went wrong in creating order");
    });
  }

  const  loadRazorpay = async (props)=> {
    // alert("razorpay")
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onerror = () => {
      alert('Razorpay SDK failed to load. Are you online?');
    };
    script.onload = async () => {
      try {
        const result = await axios.post(API.CREATE_ORDER, {
          amount: props.amount,
        }, header);
        if(result){
          console.log(result.amount + " paid")
        }
        else{
          return toastMessage("something went wrong! try again later", 'error');
        }
        console.log(result)
        const { amount, id: order_id, currency } = result.data.data;

//         RAZORPAY_KEY_ID=rzp_test_aAPRAHUGAt4n9q
// RAZORPAY_SECRET=aTQcF3HXB2DJxQjKinrpA06n
        const options = {
          key: "rzp_test_aAPRAHUGAt4n9q",
          amount: amount,
          currency: currency,
          name: 'example name',
          description: 'example transaction',
          order_id: order_id,
          handler: async function (response) {
            console.log(response);
            purchaseSubscription(props, response)
            // fetchOrders();
          },
          prefill: {
            name: 'example name',
            email: 'email@example.com',
            contact: '9999999999',
          },
          notes: {
            address: 'example address',
          },
          theme: {
            color: '#80c0f0',
          },
        };

        console.log(options)
        // setLoading(false);
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } catch (err) {
        alert(err);
        // setLoading(false);
      }
    };
    document.body.appendChild(script);
  }

  
  return {
    loadRazorpay,
    trySubscription,
    purchaseSubscription,
    customer,
    loading,
  }
}
